'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _genericCategory = require('../generic-category');

var _genericCategory2 = _interopRequireDefault(_genericCategory);

var _defaultResult = require('./default-result');

var _defaultResult2 = _interopRequireDefault(_defaultResult);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (props) {
    return _react2.default.createElement(_genericCategory2.default, _extends({}, props, {
        CategoryResult: _defaultResult2.default
    }));
};